import { AUTH_EVENTS, postAuthEvent } from "../../utils/authChannel";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Warning } from "../../assets/icons/Warning.svg";

import {
  hideIdleModal,
  showLoginModal,
  logout,
  saveLastRoute,
  clearUserInfo,
  hideLoginModal,
} from "../../store/auth/authSlice";
import { useEffect } from "react";
import { setClearClaimDetails } from "../../store/claim/claimSlice";
import { useNavigate } from "react-router-dom";
import { useGetUserDetailsMutation, useLogOutUserMutation } from "../../store/auth/usersApiSlice";

export const SessionExpired = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.auth);
  const [logOutUser] = useLogOutUserMutation();
  const [getUserDetails] = useGetUserDetailsMutation();

  const { showIdleModal, modalType } = useSelector(
    (state) => state.auth
  );

  const isIdle = modalType === "idle";
  const isExpiry = modalType === "expiry";

  const handlePrimary = async () => {
    await getUserDetails();
    dispatch(hideIdleModal());
    return;
  };

  const handleLogout = async () => {
    await logOutUser({ token })

    // Tell the other tabs before clearing this one. They share the cookies
    // that were just revoked, so without this they keep rendering a signed-in
    // UI until their next 401 — which on an idle page may never come.
    postAuthEvent(AUTH_EVENTS.SIGNED_OUT);

    dispatch(hideIdleModal());
    dispatch(logout());
    dispatch(hideLoginModal());
    dispatch(setClearClaimDetails())
    dispatch(clearUserInfo());
    navigate('/');
  };

  return (
    <div className="text-center flex flex-col items-center">

      <div className="sessionexpired mb-4">
        <Warning />
      </div>

      <h3 className="text-secondarytwo text-f20 font-semibold">
        {isIdle && "Are you still there?"}
        {isExpiry && "Session Expiring Soon"}
      </h3>

      <p className="text-secondary pt-2 pb-4 w-80 text-f14">
        {isIdle &&
          "No activity detected. Click below to stay logged in."}

        {isExpiry &&
          "Your session will expire soon. Please continue to stay logged in."}
      </p>

      <div className="w-full flex flex-col gap-3">

        <button
          onClick={handlePrimary}
          className="bg-primary px-4 py-2 text-white text-f14 rounded w-full"
        >
          {isIdle && "I'm Here"}
          {isExpiry && "Continue Session"}
        </button>

        <button
          onClick={handleLogout}
          className="border border-gray-300 px-4 py-2 text-f14 rounded w-full text-primary"
        >
          Logout
        </button>

      </div>

    </div>
  );
};
